// individual field
export { default as CropField } from './CropField';
export { default as SourceField } from './SourceField';
export { default as DestField } from './DestField';
export {
  default as FertilizersChemicalsField,
} from './FertilizersChemicalsField';
export { default as TypeField } from './TypeField';

// group of field
// export { default as HarvestingFields } from './Harvesting';
export { default as ScoutingFields } from './ScoutingFields';
export { default as SeedingFields } from './SeedingFields';



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/index.js